import ImagesSkuGreenCheckSvg from '@/public/images/sku/green-check.svg';
import ImagesSkuPlusSignSvg from '@/public/images/sku/plus-sign.svg';
import ImagesSkuPriceTagSvg from '@/public/images/sku/price-tag.svg';
import ImagesSkuShieldSvg from '@/public/images/sku/shield.svg';
import ImagesSkuSpiritoryCheckmarkSvg from '@/public/images/sku/spiritory-checkmark.svg';

export {
  ImagesSkuGreenCheckSvg,
  ImagesSkuPlusSignSvg,
  ImagesSkuPriceTagSvg,
  ImagesSkuShieldSvg,
  ImagesSkuSpiritoryCheckmarkSvg,
};
